import { CheckIcon } from '@heroicons/react/24/solid'
import { useEffect, useState, useRef } from 'react'
import { Button } from '@components/ui/button'
import { useUnsavedChanges } from '@contexts/unsavedChangesContext'

const SaveButton = ({ saving, hasChanges, isLoading, onSave }) => {
  const { setHasUnsavedChanges, setIsSaving } = useUnsavedChanges()
  const [showSavedTick, setShowSavedTick] = useState(false)
  const prevSaving = useRef(saving)

  useEffect(() => {
    setHasUnsavedChanges(hasChanges)
    setIsSaving(saving)
  }, [hasChanges, saving, setHasUnsavedChanges, setIsSaving])

  useEffect(() => {
    if (prevSaving.current && !saving && !hasChanges) {
      setShowSavedTick(true)
    } else if (hasChanges) {
      setShowSavedTick(false)
    }

    prevSaving.current = saving
  }, [saving, hasChanges])

  const isDisabled = saving || isLoading

  return (
    <div className='flex items-center gap-2'>
      {showSavedTick && <CheckIcon className='h-5 w-5 text-green-700' />}
      <Button
        variant="default"
        disabled={isDisabled}
        onClick={onSave}
      >
        {saving ? 'Saving...' : 'Save'}
      </Button>
    </div>
  )
}

export default SaveButton
